exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.ServicePrice_component_2txZ {\n  padding-left: 32px;\n  width: 140px;\n  text-align: right;\n}\n.ServicePrice_isMobile_1cHb {\n  padding: 0 0 0 58px;\n  width: 100%;\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ServicePrice_component_2txZ",
	"isMobile": "ServicePrice_isMobile_1cHb"
};